export const NOTIFICAR = 'notificacao/NOTIFICAR';
export const NOTIFICAR_SUCESSO = 'notificacao/NOTIFICAR_SUCESSO';
export const OCULTAR_NOTIFICACAO = 'notificacao/OCULTAR_NOTIFICACAO';

const exibirNotificacao = mensagem => {
  return {
    type: NOTIFICAR,
    payload: { mensagem }
  };
};

const exibirNotificacaoSucesso = mensagem => {
  return {
    type: NOTIFICAR_SUCESSO,
    payload: { mensagem }
  };
};

const ocultarNotificacao = () => {
  return {
    type: OCULTAR_NOTIFICACAO
  };
};

export { exibirNotificacao, ocultarNotificacao, exibirNotificacaoSucesso };
